module.exports = __webpack_public_path__ + "img/sam-shirt-pride-02.e257ebd0.jpg";